import { PRICING_TYPES } from '../Constant';
import { NumericEngine } from './numericEngine';

/**
 * Sum labour, parts (from labour-type services), and packages (fixed-price services)
 * from invoice/estimate API `services` (read-only display).
 * Matches table display: prefer stored line totals, else qty × rate / qty × cost + fees; fixed uses fixedPrice.
 * @returns {{ labourTotal: number, partsTotal: number, packagesTotal: number }}
 */
export function computeLabourPartsFromServices(services) {
    if (!Array.isArray(services) || services.length === 0) {
        return { labourTotal: 0, partsTotal: 0, packagesTotal: 0 };
    }

    let labourAcc = '0';
    let partsAcc = '0';
    let packagesAcc = '0';

    for (const item of services) {
        if (!item) continue;

        if (item.pricingType === PRICING_TYPES.FXIED) {
            const fp = item.fixedPrice;
            let fixedLine = '0';
            if (fp !== undefined && fp !== null && fp !== '') {
                fixedLine = NumericEngine.format(fp);
            }
            packagesAcc = NumericEngine.add(packagesAcc, fixedLine);
            continue;
        }

        if (item.pricingType !== PRICING_TYPES.LABOUR) {
            continue;
        }

        const labor = item.labor ?? item.labour;
        const qty = Number(labor?.qty) || 0;
        const rate = Number(labor?.ratePerHour) || 0;
        let laborLine = '0';
        const laborTa = labor?.totalAmount;
        if (laborTa !== undefined && laborTa !== null && laborTa !== '') {
            laborLine = NumericEngine.format(laborTa);
        } else if (qty && rate) {
            laborLine = NumericEngine.multiply(qty, rate);
        }
        labourAcc = NumericEngine.add(labourAcc, laborLine);

        const parts = item.parts || [];
        for (const prt of parts) {
            const pQty = Number(prt?.totalQty ?? prt?.qty ?? prt?.partQty) || 0;
            const pCost = Number(prt?.cost ?? prt?.retailPrice ?? prt?.partCost) || 0;
            const pFee = Number(prt?.feeAmount) || 0;
            const pTa = prt?.totalAmount;
            let partLine = '0';
            // The stored totalAmount is qty × cost ONLY — a managed part's per-unit fee ("Parts
            // disposal") lives in feeAmount and is billed on top. It must be added in either branch,
            // or this Parts row reads lower than the Subtotal it feeds (a $100 part with a $100 fee
            // showed Parts $100 against a $300 subtotal).
            if (pTa !== undefined && pTa !== null && pTa !== '') {
                partLine = NumericEngine.format(pTa);
            } else {
                partLine = pQty && pCost ? NumericEngine.multiply(pQty, pCost) : '0';
            }
            if (pQty && pFee) {
                partLine = NumericEngine.add(partLine, NumericEngine.multiply(pQty, pFee));
            }
            partsAcc = NumericEngine.add(partsAcc, partLine);
        }
    }

    return {
        labourTotal: Number(labourAcc),
        partsTotal: Number(partsAcc),
        packagesTotal: Number(packagesAcc),
    };
}
